(() => {
  const root = document.getElementById('openbox-upsell');
  if (!root) return;

  const prefix   = (root.dataset.prefix || 'OPENBOX-').trim();
  const currency = root.dataset.currency || 'USD';
  const baseSku  = (root.dataset.baseSku || '').trim();
  const coll     = (root.dataset.collection || 'open-box-deals').trim();

  const STOREFRONT_URL = window.Shopify?.routes?.root || '/';
  const STOREFRONT_API = STOREFRONT_URL + "api/2024-01/graphql.json";
  const STOREFRONT_TOKEN = "79a3656c8f60c24c95f8beee247231bd"; // 🔹 your token

  const show = () => { root.style.display = ''; };
  const hide = () => { root.style.display = 'none'; };

  const card     = root.querySelector('.openbox-card');
  const titleEl  = root.querySelector('.openbox-title');
  const priceEl  = root.querySelector('.openbox-price');
  const stockEl  = root.querySelector('.openbox-stock');
  const imgEl    = root.querySelector('img');

  const fmt = (amt, cur) => {
    const n = Number(amt);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || currency }).format(n);
    } catch {
      return `${amt} ${cur || currency}`;
    }
  };

  async function fetchCollectionPage(handle, page = 1) {
    const r = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('collection HTTP ' + r.status);
    return r.json();
  }

  async function loadProduct(handle) {
    const r = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    return r.ok ? r.json() : null;
  }

  async function fetchStockByGid(variantId) {
    const gid = String(variantId).startsWith("gid://")
      ? variantId
      : `gid://shopify/ProductVariant/${variantId}`;

    const query = `
      query getStock($id: ID!) {
        node(id: $id) {
          ... on ProductVariant {
            quantityAvailable
          }
        }
      }`;

    const res = await fetch(STOREFRONT_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables: { id: gid } }),
    });

    const json = await res.json();
    return json?.data?.node?.quantityAvailable ?? null;
  }

  async function findExact(openSku) {
    let page = 1;
    while (page <= 4) {
      const data = await fetchCollectionPage(coll, page);
      const items = data?.products || [];
      if (!items.length) break;

      for (const p of items) {
        const hit = (p.variants || []).find(v => (v.sku || '').trim() === openSku);
        if (!hit) continue;

        const full = await loadProduct(p.handle);
        if (!full) continue;
        const v = (full.variants || []).find(v => (v.sku || '').trim() === openSku);
        if (!v) continue;

        const stock = await fetchStockByGid(v.admin_graphql_api_id || v.id);

        return {
          available: !!v.available,
          price: (v.price / 100).toFixed(2),
          currency,
          url: `/products/${p.handle}`,
          title: full.title || p.title,
          image: (full.images && full.images[0]) || (p.images && p.images[0]),
          alt: 'Open-Box',
          stock
        };
      }

      if (items.length < 250) break;
      page += 1;
    }
    return null;
  }

  function render(info) {
    if (!info || !info.available) { hide(); return; }

    if (info.image) {
      imgEl.src = info.image;
      imgEl.alt = info.alt || 'Open-Box';
    }

    titleEl.textContent = info.title || 'Open-Box Item';
    priceEl.textContent = info.price ? fmt(info.price, info.currency) : '';

    if (stockEl) {
      stockEl.classList.remove("urgent", "warning", "normal");

      const qty = info.stock;
      if (typeof qty === "number" && qty > 0) {
        if (qty === 1) {
          stockEl.textContent = "Only 1 left — hurry up!";
          stockEl.classList.add("urgent");
        } else if (qty <= 3) {
          stockEl.textContent = `Only ${qty} left in stock — going fast!`;
          stockEl.classList.add("warning");
        } else if (qty <= 5) {
          stockEl.textContent = `${qty} left in stock`;
          stockEl.classList.add("normal");
        } else {
          stockEl.textContent = "In stock";
          stockEl.classList.add("normal");
        }
      } else {
        if (info.available){
          stockEl.textContent = "In stock";
          stockEl.classList.add("normal");
        } else {
          stockEl.textContent = "Out of stock";
        }
      }
    }

    card.onclick = () => (window.location.href = info.url);
    card.onkeypress = (e) => { if (e.key === 'Enter') window.location.href = info.url; };

    show();
  }

  async function runFor(sku) {
    if (!sku) return hide();
    const openSku = `${prefix}${sku}`.trim();
    try {
      render(await findExact(openSku));
    } catch {
      hide();
    }
  }

  runFor(baseSku);

  const onVariant = (e) => {
    const newSku = (e?.detail?.variant?.sku || e?.detail?.sku || '').trim();
    if (!newSku) return;
    titleEl.textContent = 'Checking availability…';
    priceEl.textContent = '';
    if (stockEl) stockEl.textContent = '';
    hide();
    runFor(newSku);
  };

  document.addEventListener('variant:change', onVariant);
  document.addEventListener('product:variant-change', onVariant);
})();
